import { Box, Text, TextButton } from '@wix/design-system';
import { CycleUtils } from '@wix/package-picker-shared';
import React, { useEffect } from 'react';
import { ECLIPSE_SALE_TEXT_COLOR } from '../../../utils';
import { useCurrentModule } from '../../ModuleProvider';
import { cycleSlug, getHigherCycleCopyKeys } from './upsellCopyKeys';
import { resolveBadgeSavingsAmount, resolveComparisonPrice } from './upsellPricing';
import s from './SwitchToHigherCycle.scss';
const BORDER_COLOR = '#CFD1DC';
export function SwitchToHigherCycle(_ref) {
  var _targetPricing$monthl, _targetPricing$discou, _currentPricing$disco;
  let {
    targetPricing,
    items,
    isSale,
    onSwitchCycle
  } = _ref;
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const targetCycleId = targetPricing.cycleId;
  const componentName = `switch to ${cycleSlug(targetPricing.cycle)}`;
  useEffect(() => {
    module.internals.bi.onSwitchCycleComponentLoad == null || module.internals.bi.onSwitchCycleComponentLoad({
      componentName,
      targetCycle: targetCycleId
    });
  }, [module, componentName, targetCycleId]);

  // Per-cycle sale map for the badge; the checkout page already issues this query.
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId: selectedProductId || ''
  }, Boolean(selectedProductId));
  const currentCycleId = selectedCycle ? CycleUtils.convertCycleToCycleId(selectedCycle) : undefined;
  const currentPricing = items.find(item => item.cycleId === currentCycleId);
  const getBadgeText = () => {
    var _product$salePerCycle;
    const savingsAmount = resolveBadgeSavingsAmount({
      isSale,
      isSaleCycle: product == null || (_product$salePerCycle = product.salePerCycle) == null ? void 0 : _product$salePerCycle[targetCycleId],
      discountFixedAmount: targetPricing.discountFixedAmount,
      savings: targetPricing.savings
    });
    if (!savingsAmount) {
      return null;
    }
    return t('checkout.summary.yearly_upsell.savings_badge.label', {
      savingsAmount
    });
  };
  const newPrice = (_targetPricing$monthl = targetPricing.monthlyFinalPrice) == null ? void 0 : _targetPricing$monthl.formattedAmount;
  const oldPrice = resolveComparisonPrice(items, currentPricing);

  // A plan outside the campaign has no discounts to compare, so it keeps the price copy.
  const targetSavings = (_targetPricing$discou = targetPricing.discountFixedAmount) == null ? void 0 : _targetPricing$discou.formattedAmount;
  const currentSavings = currentPricing == null || (_currentPricing$disco = currentPricing.discountFixedAmount) == null ? void 0 : _currentPricing$disco.formattedAmount;
  const showSaleCopy = isSale && Boolean(targetSavings) && Boolean(currentSavings);
  const {
    titleKey,
    ctaKey
  } = getHigherCycleCopyKeys(targetPricing.cycle, showSaleCopy);
  const titleValues = showSaleCopy ? {
    newSavings: targetSavings,
    currentSavings
  } : {
    newPrice,
    oldPrice
  };
  const badgeText = getBadgeText();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP3",
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: "8px",
    marginTop: "SP3",
    marginBottom: "SP3",
    width: "100%",
    boxSizing: "border-box",
    gap: "SP1"
  }, badgeText && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, /*#__PURE__*/React.createElement("span", {
    className: s.savingsBadge,
    style: {
      color: ECLIPSE_SALE_TEXT_COLOR
    }
  }, badgeText)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    className: s.upsellTitle
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: titleKey,
    values: titleValues,
    components: {
      cycle: /*#__PURE__*/React.createElement("span", {
        className: s.cycleName
      })
    }
  })), /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    weight: "bold",
    as: "span",
    role: "button",
    wrap: true,
    style: {
      height: 'auto'
    },
    onClick: () => {
      module.internals.bi.onSwitchCycleComponentClick == null || module.internals.bi.onSwitchCycleComponentClick({
        targetCycle: targetCycleId,
        componentName
      });
      onSwitchCycle(targetCycleId);
    }
  }, t(ctaKey)));
}
//# sourceMappingURL=SwitchToHigherCycle.js.map